import get from 'lodash/get';
import type { Menu } from '@/Interfaces/Data';
import { ROLE_TYPES } from '@/Interfaces/Data';
import type { CategoryMenu } from '@/_components/layout/nav-bar/types';
import { SIDE_BAR_PAGES } from '@/_components/layout/nav-bar/types';
import { useAppSelector } from '@/_store/hooks';
import { selectUser } from '@/_store/modules/auth/selectors';
import { DELIVERY_LIST_PERMISSION_KEYS } from '@/_constants/permissions';
import { isProd } from '@/_config/env';

function useNavbarMenus() {
  const user = useAppSelector(selectUser);
  const { permissions, managerLogType } = user || {};

  if (!permissions || !managerLogType) {
    return { menus: [] };
  }

  const permissionsPlace = Object.values(permissions.place);

  const isAllowedDeliveryList = DELIVERY_LIST_PERMISSION_KEYS.some(
    permissionKey => get(permissions, permissionKey),
  );

  const isAllowedDeliverymanListing =
    permissions.deliveryman.createDeliveryman ||
    permissions.deliveryman.blockDeliveryman ||
    permissions.deliveryman.dedicateDeliveryman ||
    permissions.deliveryman.editDeliveryman;

  // TODO refact this for strucuture used in partner
  const isAllowedLogisticOperator = (menu: CategoryMenu | Menu) => {
    const { key, permissions: menuPermissions } = menu;
    if (menuPermissions?.includes(ROLE_TYPES.LOGISTIC_OPERATOR)) {
      return true;
    }
    if (
      (key === 'entregas' || key === 'monitor-entregas' || key === 'pedidos') &&
      isAllowedDeliveryList
    ) {
      return true;
    }
    if (key === 'precadastro' && permissions.deliveryman.approvePreRegister) {
      return true;
    }
    if (
      (key === 'listagem' || key === 'entregadores') &&
      isAllowedDeliverymanListing
    ) {
      return true;
    }
    if (
      (key === 'gerenciamento' || key === 'estabelecimentos') &&
      permissionsPlace.some(value => value === true)
    ) {
      return true;
    }
    if (key === 'eventos' && permissions.delivery.events) {
      return true;
    }
    if (key === 'tarifas' || key === 'outros') {
      return true;
    }
    return false;
  };

  const isAllowedMenu = (menu: CategoryMenu | Menu) => {
    if (managerLogType === ROLE_TYPES.LOGISTIC_OPERATOR) {
      return isAllowedLogisticOperator(menu);
    }

    const hasPermission = menu.permissions?.includes(managerLogType);

    return !!hasPermission;
  };

  const menus: (CategoryMenu | undefined)[] = SIDE_BAR_PAGES.map(category => {
    const { menus } = category;

    const isAllowed = isAllowedMenu(category);

    if (!isAllowed) {
      return undefined;
    }

    const visibleMenus = menus.filter(menu => {
      if (menu.stageOnly && isProd) {
        return false;
      }

      return isAllowedMenu(menu);
    });

    const visibleCategory = {
      ...category,
      menus: visibleMenus,
    };

    return visibleCategory;
  });

  return { menus };
}

export { useNavbarMenus };
